import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bs-h-scroll-container" }
const _hoisted_2 = {
  key: 0,
  class: "bs-h-scroll-container__scroll scroll--top"
}
const _hoisted_3 = {
  class: "scroll__control",
  ref: "thumb"
}
const _hoisted_4 = {
  class: "bs-h-scroll-container__container",
  ref: "container"
}
const _hoisted_5 = {
  key: 1,
  class: "bs-h-scroll-container__scroll scroll--bottom"
}
const _hoisted_6 = {
  class: "scroll__control",
  ref: "thumbBottom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasScroll)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, null, 512)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "container__content",
        ref: "wrapper",
        style: _normalizeStyle({ minWidth: _ctx.minWidth })
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4)
    ], 512),
    (_ctx.hasScroll)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, null, 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}